import { GetStaticPaths, GetStaticProps } from "next";
import parlors from "goi_common/src/constants/parlors_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import {
  DTypeCompareParlor,
  EXCLUDED_IDS_BY_REGION,
  ParlorDetailProps,
  RichSearch,
  sangjoFaqRichSearch,
} from "goi_common";
import { Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const excludedSet = EXCLUDED_IDS_BY_REGION.ch ?? new Set<number>();

  const parlorList = parlors
    .filter((res) => targetSidos.includes(res.sido))
    .filter((res) => !excludedSet.has(res.id));

  let pathList = [] as Array<any>;
  let copyParlorList = [...parlorList];

  while (copyParlorList.length > 0) {
    let firstParlor = copyParlorList[0];

    if (excludedSet.has(firstParlor.id)) {
      copyParlorList.shift();
      continue;
    }

    copyParlorList.map((secondParlor) => {
      if (
        firstParlor.companyname !== secondParlor.companyname &&
        firstParlor.sigungu === secondParlor.sigungu
      ) {
        pathList.push({
          params: {
            firstid: String(firstParlor.id),
            secondid: String(secondParlor.id),
          },
        });
      }
    });
    copyParlorList.shift();
  }
  return {
    paths: pathList,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { firstid, secondid } = params as { firstid: string; secondid: string };

  const firstParlor = parlors.filter((p) => String(p.id) === firstid)[0];
  const secondParlor = parlors.filter((p) => String(p.id) === secondid)[0];

  let description = ` ${firstParlor.companyname}은 ${firstParlor.address},
   ${secondParlor.companyname}은 ${secondParlor.address}에 위치해있습니다. 두 장례식장의 상세한 내용을 알아보겠습니다. (고이장례연구소, e하늘 장사정보시스템 기반)`;

  return {
    props: {
      firstParlor,
      secondParlor,
      pageDescription: description,
      pageKeywords: `${firstParlor.companyname} 장례 서비스, ${firstParlor.companyname} 얼마, ${firstParlor.companyname} 앰뷸런스, ${firstParlor.companyname} 수의, ${firstParlor.companyname} 유골함, ${firstParlor.companyname} 도우미, ${firstParlor.companyname} 비용, ${firstParlor.companyname} 할인, ${firstParlor.companyname} 전화번호,
      ${secondParlor.companyname} 장례 서비스, ${secondParlor.companyname} 얼마, ${secondParlor.companyname} 앰뷸런스, ${secondParlor.companyname} 수의, ${secondParlor.companyname} 유골함, ${secondParlor.companyname} 도우미, ${secondParlor.companyname} 비용, ${secondParlor.companyname} 할인, ${secondParlor.companyname} 전화번호`,
      pageOgTitle: `${firstParlor.companyname}, ${secondParlor.companyname} 비교 ::  충청대전세종장례소개 [고이장례연구소]`,
      pageOgDescription: description,
      pageOgImage: firstParlor?.images[0]?.url || "",
    },
  };
};

export default function placeComaprePage({
  firstParlor,
  secondParlor,
  pageOgTitle,
}: {
  firstParlor: ParlorDetailProps;
  secondParlor: ParlorDetailProps;
  pageOgTitle: string;
}) {
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>

        <RichSearch data={sangjoFaqRichSearch} />
      </Head>
      <Stack>
        <DTypeCompareParlor
          firstParlor={firstParlor}
          secondParlor={secondParlor}
          mainColor={regionColor}
          sido={firstParlor.sido}
          sigungu={firstParlor.sigungu}
          event={{
            domain: "ch",
            path: "chk_compare",
            trigger_and_target: "uv_prlr_detail",
          }}
        />
      </Stack>
    </>
  );
}
